import { computed, reactive } from "vue-demi";

import { useApi } from "@/composables/api/api";
import { useI18n } from "@/composables/i18n";

export function useDataTable(measure) {
  const { t } = useI18n();
  const { data, loading } = useApi(`/dashboard/${measure}/table`);

  const headers = computed(() => {
    if (!data.value) return [];

    return Object.keys(data.value[0]).map(header => ({
      text: t(`widgets.${measure}.table.${header}`),
      value: header
    }));
  });

  const onRowClick = item => {
    console.log(item);
  };

  const tableProps = reactive({
    footerProps: {
      "items-per-page-options": [10, 20, 50]
    }
  });

  return {
    data,
    loading,
    headers,
    onRowClick,
    tableProps
  };
}
